<template>
  <div class="app-container app-theme-white body-tabs-shadow">
    <div class="app-container">
      <div class="h-100">
        <div class="h-100 no-gutters row">
          <div class="d-none d-lg-block col-lg-4">
            <div class="slider-light">
              <div class="slick-slider">
                <div>
                  <div
                    class="position-relative h-100 d-flex justify-content-center align-items-center bg-plum-plate"
                    tabindex="-1"
                  >
                    <div
                      class="slide-img-bg"
                      style="background-image: url('assets/images/originals/city.jpg');"
                    ></div>
                    <div class="slider-content">
                      <h3>Inicio de sesion</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-8"
          >
            <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
              <div class="app-logo"></div>
              <h4 class="mb-0">
                <span class="d-block">Estudio Baraybar</span>
                <span>Ingrese sus datos.</span>
              </h4>
              <div class="divider row"></div>
              <div>
                <form @submit.prevent="login">
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="position-relative form-group">
                        <label for="exampleEmail" class>Usuario</label>
                        <input
                          v-model="d.usuario"
                          name="usuario"
                          id="exampleEmail"
                          placeholder="Usuario"
                          type="text"
                          class="form-control"
                          :class="(enviado && !$v.d.usuario.required) ? 'is-invalid' : ''"
                        />
                         <div class="invalid-feedback" v-if="enviado && !$v.d.usuario.required">Ingrese su usuario</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="position-relative form-group">
                        <label for="examplePassword" class>Contraseña</label>
                          <input v-model="d.password" id="password" placeholder="Ingresar contraseña..." type="password" class="form-control" :class="(enviado && !$v.d.password.required) ? 'is-invalid' : ''" />
                          <div class="invalid-feedback" v-if="enviado && !$v.d.password.required">Ingrese su contraseña</div>
                      </div>
                    </div>
                  </div>
                  <div class="divider row"></div>
                  <div class="d-flex align-items-center">
                    <div class="ml-auto">
                      <button class="btn btn-primary btn-lg">Iniciar sesión</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import Swal from "sweetalert2";
import Vuex from "vuex";
export default {
  name: "Login",
  components: {
    },
  data(){
        return {
            d: {},
            enviado:false
        }
    },
    validations:{
        d:{
            usuario:{required},
            password:{required},           
        }
    },
    computed:{
        ...Vuex.mapState(['user', 'credentials', 'token']),
    },
  created() {
    
  },
  methods: {
    login() {
      this.enviado = true
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      //this.d.usuario="123456789";
      //this.d.password = "123456";
      this.$store.dispatch("login", this.d).catch(()=>{
        Swal.fire({
          icon: "error",
          title: "Oopss..",
          text: `El usuario y la contraseña no son validas.`
        });
      });
      
    },
  },
};
</script>